export type CadenceType = 'daily' | 'weekly';

export type WeeklyCadenceValue = 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday';

export const DaysOfTheWeek: WeeklyCadenceValue[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export interface Cadence {
  type: CadenceType;
  value: WeeklyCadenceValue[];
}

export type FrequencyType = 'one-time' | 'recurring';

export interface OfferModalForm {
  rateStr: string;
  rateTypeStr: 'apr' | 'disc' | undefined;
  isAgreementsChecked: boolean;
  frequency: FrequencyType;
  enableSchedule: boolean;
  cadence: Cadence;
  startDate?: string;
  endDate?: string;
}

export type ScheduleInput =
  | {
      daysOfWeek?: WeeklyCadenceValue[];
      startDate?: string;
      endDate?: string;
    }
  | undefined
  | null;
